import { useEffect } from 'react';
import { claimPublishedTitle } from '../lib/documentTitleOwners';

export const safeHttpUrl = value => {
  if (typeof value !== 'string' || value.length > 2048 || /[\\\u0000-\u0020\u007f]/.test(value)) return null;
  try { const url = new URL(value); return ['https:', 'http:'].includes(url.protocol) ? value : null; } catch { return null; }
};

export default function usePublishedMetadata(item, panelName) {
  useEffect(() => {
    if (!item) return undefined;
    const cleanups = [];
    const title = claimPublishedTitle(item.meta_title || item.header_title || item.name || panelName || document.title);
    const metadata = new Map();
    for (const entry of item.header_meta || []) {
      const attribute = entry.property ? 'property' : 'name', key = entry[attribute];
      if (typeof key === 'string' && /^[a-zA-Z0-9._:-]{1,100}$/.test(key) && typeof entry.content === 'string') metadata.set(`${attribute}:${key}`, { attribute, key, content: entry.content });
    }
    if (item.meta_description) metadata.set('name:description', { attribute: 'name', key: 'description', content: item.meta_description });
    if (item.meta_keywords) metadata.set('name:keywords', { attribute: 'name', key: 'keywords', content: item.meta_keywords });
    const update = (tag, attribute, key, attributes) => {
      let node = [...document.head.querySelectorAll(tag)].find(candidate => candidate.getAttribute(attribute) === key);
      if (node) {
        const previous = [...node.attributes].map(value => [value.name, value.value]);
        cleanups.push(() => { [...node.attributes].forEach(value => node.removeAttribute(value.name)); previous.forEach(([name, value]) => node.setAttribute(name, value)); });
      } else { node = document.createElement(tag); document.head.appendChild(node); cleanups.push(() => node.remove()); }
      Object.entries(attributes).forEach(([name, value]) => node.setAttribute(name, value));
    };
    metadata.forEach(({ attribute, key, content }) => update('meta', attribute, key, { [attribute]: key, content }));
    const canonical = safeHttpUrl(item.canonical_url);
    if (canonical) update('link', 'rel', 'canonical', { rel: 'canonical', href: canonical });
    return () => { title.release(); cleanups.reverse().forEach(cleanup => cleanup()); };
  }, [item, panelName]);
}
